import axios from "axios";


function getKhachHangKhaoSat(){
  return axios.get(process.env.REACT_APP_URL_SERVER+"/cus/personal/thongke/khachhangkhaosat");
};
function getChiTietKhachHangKhaoSat(id){
  return axios.get(process.env.REACT_APP_URL_SERVER+"/cus/personal/thongke/khachhang?id="+id);
};
const ThongKePersonalService={
  getKhachHangKhaoSat,
  getChiTietKhachHangKhaoSat
};
export default ThongKePersonalService;
